<div class="command-config-detail">
  <p class="editor-hint">{{ subtitle() }}</p>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() | translate }}</div>
  }

  @if (loading()) {
    <app-loading [loading]="true"></app-loading>
  } @else if (section()) {
    <p class="editor-hint">{{ description() | translate }}</p>
    @if (restartRequired()) {
      <p class="editor-hint">{{ 'Restart the API host to apply GeoServer volumes and singleton TIFF generators.' | translate }}</p>
    }
    <app-config-json-fields
      [fields]="fields()"
      (fieldChange)="onField($event)"
      (listChange)="onList($event)"
    ></app-config-json-fields>
    <div class="dialog-actions">
      <app-primary-button
        title="Save"
        icon="pi pi-save"
        [disable]="saving()"
        (action)="save()"
      ></app-primary-button>
      <app-secondary-button
        title="Revert to host"
        icon="pi pi-undo"
        [disable]="saving() || !canRevert()"
        (action)="revertToHost()"
      ></app-secondary-button>
    </div>
  }
</div>
